// Memory-backed storage helpers: localStorage can be blocked (privacy mode,
// disabled cookies/site data) and then throws on access. Fall back to a
// module-level Map that keeps values for the page's life.
const memory = new Map();

export const getLocal = (key) => {
    if (memory.has(key)) return memory.get(key);
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
};

export const setLocal = (key, value) => {
    const str = String(value);
    try {
        localStorage.setItem(key, str);
        memory.delete(key);
    } catch {
        memory.set(key, str);
    }
};

export const removeLocal = (key) => {
    memory.delete(key);
    try {
        localStorage.removeItem(key);
    } catch {}
};

export const setLocalStorage = (key, value) => {
    const toStore = typeof value === "string" ? value : JSON.stringify(value);
    const oldValue = getLocal(key);

    if (oldValue !== toStore) {
        setLocal(key, toStore);
        window.dispatchEvent(new Event("localStorageChanged"));
    }
};
